// extracted by mini-css-extract-plugin
export default {"BACKGROUND_GRAY":"#F8F9FC","loaderWrapper":"app_loaderWrapper__m2Ty9","app":"app_app__sRM-7"};